import React from 'react'
import {connect} from 'react-redux'
import {MetalColor, Finish, Gemstones, NextSteps, RingFaceShape, RaisedOrRecessed, RingFaceSize, ShoulderDesigns} from './shared'

const METAL_COLOR_CARDS = [
  {
    name: "silver_color",
    img: "//images.custommade.com/W97J3QKKBSLooPrnl_gPo94UXhg=/custommade-attachments/0f14d8eec5afb14_crf_images_2_metal_color_23b8e15b1d2b44d_724033_1_2.jpg",
    label: "White Gold, Silver, Platinum"
  },
  {
    name: "yellow",
    img: "//images.custommade.com/rYF9XUyQC6YqxP2lsFzDaP34tm0=/custommade-attachments/9ab44d031ee6551_crf_images_2_metal_color_0f97f8f7863cfb5_749430_1_2.jpg",
    label: "Yellow Gold"
  },
  {
    name: "rose",
    img: "//images.custommade.com/Rgu5TdONAdz7I-TtWiI4-9S90Pc=/custommade-attachments/494a613d1a930df_crf_images_2_metal_color_73d6c0bfdb360df_632182_1.jpg",
    label: "Rose Gold"
  },
  {
    name: "mixed_metals",
    img: "//images.custommade.com/ODZyUTzz4p46-YYSqymDT0Ky8LU=/custommade-attachments/a9c4b6eac670a86_crf_images_2_metal_color_97f4e4ec2b2505a_740116_1.jpg",
    label: "Mixed Metals"
  }
]

export class ClassRingMetalColor extends React.Component {

  render(){
    return (
      <MetalColor cards={METAL_COLOR_CARDS} {...this.props} />
    )
  }
}


const FINISH_CARDS = [
  {
    name: "polished",
    img: "//images.custommade.com/VwuHb72KZEIvTGhld6Vpbg9MEFs=/custommade-attachments/70d43d5ca38f457_class_polished.jpg",
    label: "Polished"
  },
  {
    name: "brushed",
    img: "//images.custommade.com/CdKCRLXvAicTsq8jr_xoL0jTftY=/custommade-attachments/65adc3c8d6441a0_class_brushed.jpg",
    label: "Brushed"
  },
  {
    name: "oxidized",
    img: "//images.custommade.com/E_xHN2bIPX6WeMBJL5OFhfPFD7Y=/custommade-attachments/7f8a135a190e9dc_crf_images_3_finish_e4a71b113dbdd4a_652454_1.jpg",
    label: "Oxidized"
  },
  {
    name: "enamel",
    img: "//images.custommade.com/KB3PHKf7S41BFsZft-P3z2azs44=/custommade-attachments/bf42ae092aae11f_class_enamel.jpg",
    label: "Enamel"
  }
]


export class ClassRingFinish extends React.Component {

  render(){
    return (
      <Finish cards={FINISH_CARDS} {...this.props} />
    )
  }
}


const GEMSTONES_CARDS = [
  {
    name: "no_stone",
    img: "//images.custommade.com/d71G4fkhipSmwYRqHfamFrjKv34=/custommade-attachments/b8e5fed2c429bbb_crf_images_4_gemstones_897473896c25248_704401_1.jpg",
    label: "No Stone"
  },
  {
    name: "center_stone",
    img: "//images.custommade.com/AiV3r22daT5w8jMO1nW0zSOZqlA=/custommade-attachments/56f30e8ba302c81_crf_images_4_gemstones_a030b6941655cb0_737857_1.jpg",
    label: "Center Stone"
  },
  {
    name: "halo",
    img: "//images.custommade.com/TrPyuzvUME41PkW-Dkl_MmSz0xU=/custommade-attachments/17145d3a5cb992e_crf_images_4_gemstones_00ac51c6ef6c8d4_725643_1.jpg",
    label: "Halo"
  },
  {
    name: "accent_stones",
    img: "//images.custommade.com/D9F6LN8K_d5TgzfCdlbH-EK9Vf8=/custommade-attachments/f5ce55df4ad7cbd_crf_images_4_gemstones_cdb082c5cd4c7a8_517010_13.jpg",
    label: "Accent Stones"
  }
]

export class ClassRingGemstones extends React.Component {

  render(){
    return (
      <Gemstones cards={GEMSTONES_CARDS} {...this.props} />
    )
  }
}

const RING_FACE_SHAPE_CARDS = [
  {
    name: "circle",
    img: "//images.custommade.com/W1wEXchbtFGIyddairTnRT6oQik=/custommade-attachments/96c7be21cfea07b_crf_images_5_ring_face_shape_fccb7a9a75cd7c6_681416_2.jpg",
    label: "Circle"
  },
  {
    name: "portrait_oval",
    img: "//images.custommade.com/z2VQ7WV0idUOi5NX24h5wWIZBNs=/custommade-attachments/fb9e34df46ea76b_crf_images_5_ring_face_shape_ff16fc515590e77_545321_2.jpg",
    label: "Portrait Oval"
  },
  {
    name: "landscape_oval",
    img: "//images.custommade.com/Ue2AuFTeGLvAz2Zg2XS_9BN1SmY=/custommade-attachments/1ea22857ea5128c_crf_images_5_ring_face_shape_59e757dc9781e45_762067_1.jpg",
    label: "Landscape Oval"
  },
  {
    name: "square",
    img: "//images.custommade.com/SzYbX7ly1PKBBHTstw6bTxqOjZg=/custommade-attachments/0ad4abf939071c5_crf_images_5_ring_face_shape_f0a6b7d6649798e_728569_1_2.jpg",
    label: "Square"
  },
  {
    name: "portrait_rectangle",
    img: "//images.custommade.com/94dxSeuvoFZgn_nNDMRCwlqsJ6c=/custommade-attachments/f57da82aecf1c1b_crf_images_5_ring_face_shape_da2d1d83fcab913_556387_1.jpg",
    label: "Portrait Rectangle"
  },
  {
    name: "landscape_rectangle",
    img: "//images.custommade.com/raPnGYvqo1X1gwSN6Zij8JNF3PE=/custommade-attachments/4aabc085f095546_crf_images_5_ring_face_shape_4c558d04004d4c8_592202_1.jpg",
    label: "Landscape Rectangle",
    smallText: true
  },
  {
    name: "custom",
    img: "//images.custommade.com/H5yQPgRLzKj-fgSF4gVpWkiwXNA=/custommade-attachments/d7c35fd6cb5d8e5_crf_images_5_ring_face_shape_35854f606da0d34_721010_2.jpg",
    label: "Custom"
  },
]

export class ClassRingFaceShape extends React.Component {

  render(){
    return (
      <RingFaceShape cards={RING_FACE_SHAPE_CARDS} {...this.props} />
    )
  }
}


const RAISED_OR_RECESSED_CARDS = [
  {
    name: "raised",
    imgs: [
      "//images.custommade.com/Ku56Mow7Id33kP42fO8T1zRyzl8=/custommade-attachments/e149df413e531de_crf_images_6_raised_or_recessed_raised_7763a9cec2568ea_664138_1.jpg",
      "//images.custommade.com/WDNnGXOyBnIUKYSzP1V87fvf1yw=/custommade-attachments/e1f68506a7e8a30_crf_images_6_raised_or_recessed_raised_74dccb34b798ea8_740726_1.jpg",
      "//images.custommade.com/4q0xlPParMHInuDLBatk6fQAlug=/custommade-attachments/9875ede7f719d0e_crf_images_6_raised_or_recessed_raised_02489854e2a0bcb_585817_1.jpg",
    ],
    label: "Raised"
  },
  {
    name: "recessed",
    imgs: [
      "//images.custommade.com/hM0wTxE99KkCO7UBuqItPhEewlc=/custommade-attachments/beb6d1352c5e902_crf_images_6_raised_or_recessed_recessed_da2d1d83fcab913_556387_1.jpg",
      "//images.custommade.com/08EMKvJTeM8axxrIBjVMQZoi5yE=/custommade-attachments/b7815ab7bc5410b_crf_images_6_raised_or_recessed_recessed_2061aa71c59e3fd_519748_6.jpg",
      "//images.custommade.com/Klf-4mRHV2vXPca8tctAErd1IRI=/custommade-attachments/8f442b6fa93b24c_crf_images_6_raised_or_recessed_recessed_fdf544b06b8cdd7_734177_1.jpg",
    ],
    label: "Recessed"
  },
  {
    name: "recessed_and_mirrored",
    imgs: [
      "//images.custommade.com/2hfc6dwpjfF_lPB1yHyD9iHahk8=/custommade-attachments/e10369b727e2c20_crf_images_6_raised_or_recessed_recessed_and_mirrored_688cdd9472f48d0_707301_1.jpg",
      "//images.custommade.com/P9gzrTfa5OBGmSU9vDelCypR8vk=/custommade-attachments/a88e7fce0a9aada_crf_images_6_raised_or_recessed_recessed_and_mirrored_45e94409fd1bb2b_746317_1.jpg",
      "//images.custommade.com/eTMkjcZTMcjnXY5vwb9fT021jVQ=/custommade-attachments/8716f16e08da3ab_crf_images_6_raised_or_recessed_recessed_and_mirrored_8ed601053107687_695878_1.jpg",
    ],
    label: "Recessed and Mirrored"
  }
]

export class ClassRingRaisedOrRecessed extends React.Component {

  render(){
    return (
      <RaisedOrRecessed cards={RAISED_OR_RECESSED_CARDS} {...this.props} />
    )
  }
}

const RING_FACE_SIZE_IMAGES = {
  "female": "//images.custommade.com/w3fdULNIVkq6BZVzjQgjrfKtuwI=/custommade-attachments/0729cdfc7baffd9_female_hand.jpeg",
  "male": "//images.custommade.com/-kalOTEjwJsbYg0PSP9eTrvpnY0=/custommade-attachments/24599f36dea9cba_male_hand.jpg",
  "face_size": "//images.custommade.com/NmDB_mSk1gTgJx9P9Q8AnmWdasI=/custommade-attachments/8970b927e848854_crf_images_7_ring_face_size_49b9d77b9acf21b_1440_copy_5.png",
}

export class ClassRingFaceSize extends React.Component {

  render(){
    return (
      <RingFaceSize cards={RING_FACE_SIZE_IMAGES} {...this.props} />
    )
  }
}


const SHOULDER_DESIGNS = [
  {
    name: "same_on_both_sides",
    imgs: [
      "//images.custommade.com/VTHTKDpmuRLTjw13oQRCxYW0YkE=/custommade-attachments/7ec297acb99b6c0_crf_images_8_shoulder_designs_same_24129ae869a3b9c_705757_2.jpg",
      "//images.custommade.com/Q29JvjMtomIjCzq7oAKbUj5dvfY=/custommade-attachments/84e10792da2c124_crf_images_8_shoulder_designs_same_ffe1e93e9bbdab7_643367_3.jpg",
      "//images.custommade.com/imkL98AtfcDY2usZjvupgTZXD7Q=/custommade-attachments/c3bc86ca953e146_crf_images_8_shoulder_designs_same_e05e4b88351e9be_588496_5.jpg",
    ],
    label: "Same on both sides"
  },
  {
    name: "different",
    imgs: [
      "//images.custommade.com/z_wVT4e4a2Av5t0qH6iGb_k6Rh8=/custommade-attachments/5e18e40ff2cc89e_crf_images_8_shoulder_designs_different_image_1.jpg",
      "//images.custommade.com/GeLuhTICpUY9I1Lm6bH0XeyPo_E=/custommade-attachments/a4a2d5791a3f4b8_crf_images_8_shoulder_designs_different_image_2.jpg",
      "//images.custommade.com/XStdSbR4-eVumZsiCUleF2wKQ14=/custommade-attachments/783945eb0eaa629_crf_images_8_shoulder_designs_different_image_3.jpg",
    ],
    label: "Different design on each side"
  },
  {
    name: "no_designs",
    imgs: [
      "//images.custommade.com/PClHENmkUV4lU-jMmBiyjrIjsQM=/custommade-attachments/2e34c66765f73ba_crf_images_8_shoulder_designs_no_design_0f97f8f7863cfb5_749430_1_2.jpg",
      "//images.custommade.com/QDsXxCYVnS684AdT0BfaMThY88U=/custommade-attachments/373c97825bf5507_crf_images_8_shoulder_designs_no_design_9440902471f6def_527773_4.jpg",
      "//images.custommade.com/Vhr2zMJ9cAAJkildeZyu-a9esEo=/custommade-attachments/38bfebf009b87d8_crf_images_8_shoulder_designs_no_design_98e1dda685a1614_599789_3.jpg",
    ],
    label: "No shoulder design"
  }
]

export class ClassRingShoulderDesigns extends React.Component {

  render(){
    return (
      <ShoulderDesigns cards={SHOULDER_DESIGNS} {...this.props} />
    )
  }
}


const NEXT_STEPS_CARDS = [
  {
    name: "price",
    description: "Our design experts will prepare some initial quotes for you to review as a starting point for your ring.",
    label: "I’d like to discuss price first."
  },
  {
    name: "questions",
    description: "If you have other things you’d like to discuss before our team gets started, let us know - one of our ring consultants will get in touch.",
    label: "I have questions to ask or other details to share first."
  },
  {
    name: "looking_around",
    description: "Just looking around for now? We’ll hold onto your details and you can let us know when you’re ready to get started.",
    label: "I’m not ready for a consultation yet."
  }
]


@connect(state => ({
  nextSteps: state.projectCreationData.nextSteps
}))
export class ClassRingNextSteps extends React.Component {


  render(){
    return (
      <NextSteps cards={NEXT_STEPS_CARDS} {...this.props} />
    )
  }
}
